import {connect} from '@modifi/redux'
import {selectLocale} from '@modifi/plugin-i18n'
import {aFetchAnnouncementData, selectAnnouncementToBeDisplayed} from '@modifi/plugin-banners'

import Layout from './Layout'

const mapStateToProps = state => ({
  locale: selectLocale(state),
  hasAnyAnnouncements: !!selectAnnouncementToBeDisplayed(state)?.expiry,
})
const mapDispatchToProps = {
  fetchAnnouncementData: aFetchAnnouncementData,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
